/* eslint-disable */
import "./Reports.css";
import React from "react";
import moment from "moment";
import "../../css/table.css";
import "moment/locale/pt-br";
import ReactTable from "react-table";
import { connect } from "react-redux";
import Card from "../../components/Card/Card.jsx";
import { db } from "../../services/firebase";
import Modal from "../../components/Modal/Modal.jsx";
import Chart from "../../components/Chart/Chart.jsx";
import { toArray, map, orderBy } from "lodash";
import { Grid, Row, Col } from "react-bootstrap";
import ReportFilterForm from "../../forms/ReportFilterForm.jsx";
import Button from "../../elements/CustomButton/CustomButton.jsx";

class Reports extends React.Component {
  state = {
    fetching: false,
    data: [],
    queryParams: {},
    initialValues: null,
    columns: [
      { Header: "Dia/Hora", accessor: "registeredAt" },
      { Header: "Meta (gramas)", accessor: "goal" },
      { Header: "Registrado (gramas)", accessor: "registered" },
    ],
    filterModal: false,
  };

  render() {
    const { columns, data } = this.state;
    return (
      <div className="main-content">
        {this._renderFilterModal()}
        <Grid fluid>
          <Card
            content={
              <div>
                {this._renderFilterButton(data)}
                {this._handleContent()}
              </div>
            }
          />
        </Grid>
      </div>
    );
  }

  _handleContent = () => {
    const { columns, data, fetching } = this.state;
    if (fetching && !data.length) {
      return (
        <div>
          <h3>Buscando dados...</h3>
        </div>
      );
    }

    if (!fetching && !data.length) {
      return (
        <div>
          <h3>
            Nenhum dado encontrado
            <br />
            <small>
              Altere as condições de pesquisa clicando no botão <b>Filtros</b>
            </small>
          </h3>
        </div>
      );
    }

    if (!fetching && data.length) {
      return (
        <div>
          {this._renderQueryParams()}
          {this._renderChart(data)}
          {this._renderTable(columns)(data)}
          {this._renderRawList(data)}
        </div>
      );
    }
  };

  _renderFilterButton = (data) => (
    <Row className="hide-to-print">
      <Col md={12}>
        <Button
          bsStyle="default"
          wd
          className="pull-right"
          style={{ marginBottom: 10 }}
          onClick={() => this.setState({ filterModal: true })}
        >
          Filtros
        </Button>

        {data && data.length ? (
          <Button
            bsStyle="default"
            wd
            className="pull-right"
            style={{ marginBottom: 10, marginRight: 10 }}
            onClick={() => window.print()}
          >
            Imprimir
          </Button>
        ) : null}
      </Col>
    </Row>
  );

  _renderQueryParams = () => {
    const {
      product,
      indicator,
      from,
      to,
      shift,
      place,
      line,
      table,
      user,
      goal,
      avg,
    } = this.state.queryParams;
    return (
      <Row>
        <Col lg={7} md={12}>
          <h3>
            {product || "Nenhum produto"} - {indicator || "Nenhum indicador"}
            <br />
            <small>
              Período: de{" "}
              {moment(from).startOf("day").format("DD/MM/YYYY - HH:mm")} até{" "}
              {moment(to).endOf("day").format("DD/MM/YYYY - HH:mm")}
            </small>
            <br />
            <small>
              {shift || "Todos os turnos"} | {place || "Todos os locais"} |{" "}
              {line || "Todas as linhas"} | {table || "Todas as mesas"}
            </small>
            <br />
            <small>
              {user
                ? `Coletor responsável: ${user}`
                : "Dados de todos os coletores"}
            </small>
          </h3>
          <br />
        </Col>
        <Col lg={5} md={12} style={{ position: "relative" }}>
          <div
            className="reports__goal-box"
            style={{ flexDirection: "column" }}
          >
            <h6 className="reports__goal-header">META</h6>
            <h1 className="reports__goal">{Number(goal).toFixed(1) || "-"}</h1>
            <h6 className="reports__goal-footer">GRAMAS</h6>
          </div>

          <div className="reports__avg-box" style={{ flexDirection: "column" }}>
            <h6 className="reports__avg-header">MÉDIA</h6>
            <h1
              className={`
                            reports__avg 
                            ${avg <= goal && `text-success`} 
                            ${avg > goal && `text-danger`}
                            `}
            >
              {Number(avg).toFixed(1) || "-"}
            </h1>
            <h6 className="reports__avg-footer">GRAMAS</h6>
          </div>
          <h3>
            &nbsp; <br />
            <small>&nbsp;</small>
            <br />
            <small>&nbsp;</small>
            <br />
            <small>&nbsp;</small>
          </h3>
          <br />
        </Col>
      </Row>
    );
  };

  _renderTable = (columns) => (data) =>
    (
      <Row className="hide-to-print">
        <Col md={12}>
          <ReactTable
            columns={columns}
            data={data}
            loading={this.state.fetching}
            defaultPageSize={10}
            className="-striped -highlight"
            previousText="Anterior"
            nextText="Próximo"
            loadingText="Carregando"
            noDataText="Nenhum registro encontrado"
            pageText="Página"
            ofText="de"
            rowsText="Registros"
          />
        </Col>
      </Row>
    );

  _renderRawList = (data) => {
    const filteredData = [];

    data.map((x) => {
      return filteredData.push({
        ...x,
        product: `${x.product} - ${x.indicator}`,
      });
    });

    const columns = [
      { Header: "Dia/Hora", accessor: "registeredAt" },
      { Header: "Produto/Indicador", accessor: "product" },
      { Header: "Meta (gramas)", accessor: "goal" },
      { Header: "Registrado (gramas)", accessor: "registered" },
    ];

    return (
      <Row className="hide-to-render">
        <Col md={12}>
          <ReactTable
            columns={columns}
            data={filteredData}
            loading={this.state.fetching}
            pageSize={filteredData.length}
            className="-striped -highlight"
            loadingText="Carregando"
            noDataText="Nenhum registro encontrado"
            showPagination={false}
          />
        </Col>
      </Row>
    );
  };

  _renderChart = (data) => {
    return (
      <div className="chart__container-spacer">
        <div className="chart__container">
          <Chart
            data={data}
            lines={[
              { name: "Meta", dataKey: "goal", stroke: "#82CA9D" },
              { name: "Registrado", dataKey: "registered", stroke: "#6C1137" },
            ]}
            XAxisDataKey="registeredAt"
            brushDataKey="registeredAt"
          />
        </div>
      </div>
    );
  };

  _renderFilterModal = () => (
    <Modal
      size="modal__big"
      isOpen={this.state.filterModal}
      content={
        <ReportFilterForm
          companyID={this.props.user.company}
          initialValues={this.state.initialValues}
          onSubmit={(values) => this._createFilter(values)}
          handleCancel={() => this.setState({ filterModal: false })}
        />
      }
    />
  );

  _createFilter = (values) => {
    const data = {};
    const params = {};
    let totalWeight = 0;
    const DateArray = [];
    const PromiseStack = [];
    this.setState({
      initialValues: values,
      fetching: true,
      filterModal: false,
    });

    let fetch = db
      .collection("companies")
      .doc(this.props.user.company)
      .collection("results");

    const productRef = db
      .collection("companies")
      .doc(this.props.user.company)
      .collection("products");
    const indicatorRef = db
      .collection("companies")
      .doc(this.props.user.company)
      .collection("indicators");
    const shiftRef = db
      .collection("companies")
      .doc(this.props.user.company)
      .collection("shifts");
    const placeRef = db
      .collection("companies")
      .doc(this.props.user.company)
      .collection("places");
    const lineRef = db
      .collection("companies")
      .doc(this.props.user.company)
      .collection("lines");
    const tableRef = db
      .collection("companies")
      .doc(this.props.user.company)
      .collection("tables");
    const userRef = db.collection("users");

    values.product
      ? (fetch = fetch.where("product", "==", values.product.value))
      : null;
    values.indicator
      ? (fetch = fetch.where("indicator", "==", values.indicator.value))
      : null;
    values.shift ? (fetch = fetch.where("shift", "==", values.shift)) : null;
    values.place
      ? (fetch = fetch.where("place", "==", values.place.value))
      : null;
    values.line ? (fetch = fetch.where("line", "==", values.line.value)) : null;
    values.table
      ? (fetch = fetch.where("table", "==", values.table.value))
      : null;
    values.user ? (fetch = fetch.where("user", "==", values.user.value)) : null;
    values.from
      ? (fetch = fetch.where(
          "registeredAt",
          ">=",
          Number(moment(values.from._d).startOf("day").format("x"))
        ))
      : null;
    values.to
      ? (fetch = fetch.where(
          "registeredAt",
          "<=",
          Number(moment(values.to._d).endOf("day").format("x"))
        ))
      : null;

    return fetch.get().then((results) => {
      if (!results.empty) {
        results.forEach((result) => {
          const {
            product,
            registered,
            registeredAt,
            indicator,
            shift,
            place,
            line,
            table,
            user,
          } = result.data();

          data[result.id] = {
            ...result.data(),
            registeredAt: moment(registeredAt).format("DD/MM/YYYY - HH:mm"),
          };

          totalWeight += registered;
          !values.from && !values.to
            ? DateArray.push(result.data().registeredAt)
            : null;

          PromiseStack.push(
            productRef
              .doc(product)
              .get()
              .then((snap) => {
                data[result.id].product = snap.data().name;
                params.product = snap.data().name;
              })
              .catch((e) => console.log(e)),

            indicatorRef
              .doc(indicator)
              .get()
              .then((snap) => {
                data[result.id].indicator = snap.data().name;
                params.indicator = snap.data().name;
                params.goal = snap.data().goal;
              })
              .catch((e) => console.log(e)),

            shiftRef
              .doc(shift.value || shift)
              .get()
              .then((snap) => {
                data[result.id].shift = snap.data().name;
                values.shift ? (params.shift = snap.data().name) : null;
              })
              .catch((e) => console.log(e)),

            placeRef
              .doc(place)
              .get()
              .then((snap) => {
                data[result.id].place = snap.data().name;
                values.place ? (params.place = snap.data().name) : null;
              })
              .catch((e) => console.log(e)),

            lineRef
              .doc(line)
              .get()
              .then((snap) => {
                data[result.id].line = snap.data().name;
                values.line ? (params.line = snap.data().name) : null;
              })
              .catch((e) => console.log(e)),

            tableRef
              .doc(table)
              .get()
              .then((snap) => {
                data[result.id].table = snap.data().name;
                values.table ? (params.table = snap.data().name) : null;
              })
              .catch((e) => console.log(e)),

            userRef
              .doc(user)
              .get()
              .then((snap) => {
                data[result.id].user = snap.data().name;
                values.user ? (params.user = snap.data().name) : null;
              })
              .catch((e) => console.log(e))
          );
        });
        Promise.all(PromiseStack)
          .then(() => {
            if (values.from && values.to) {
              params.from = values.from;
              params.to = values.to;
            } else {
              params.from = Math.min.apply(Math, DateArray);
              params.to = Math.max.apply(Math, DateArray);
            }

            params.avg = totalWeight / results.size;
            this.setState({
              queryParams: params,
              data: toArray(data),
              fetching: false,
            });
          })
          .catch((e) => console.log(e));
      } else {
        this.setState({ data: toArray(data), fetching: false });
      }
    });
  };
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps, null)(Reports);



// WEBPACK FOOTER //
// ./src/views/Reports/Reports.jsx